import { z } from 'zod';
import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';

export const tourBudgetSchema = z.object({
  currency: z.enum(Currency, { error: 'Waluta jest wymagana' }),
  fixedAmount: z
    .number({ error: 'Kwota podstawowa jest wymagana' })
    .min(0, 'Kwota nie może być ujemna'),
  perParticipantAmount: z
    .number({ error: 'Kwota na uczestnika jest wymagana' })
    .min(0, 'Kwota nie może być ujemna'),
});

export type TourBudgetFormData = z.infer<typeof tourBudgetSchema>;
